import { useLocation } from "react-router-dom";

const useLangPrefix = (): string => {
  const location = useLocation();
  const isEn =
    location.pathname === "/en" || location.pathname.startsWith("/en/");
  return isEn ? "/en" : "";
};

export default useLangPrefix;
